import { render, staticRenderFns } from "./GiveworksForm.vue?vue&type=template&id=0db9b7c9&"
import script from "./GiveworksForm.vue?vue&type=script&lang=js&"
export * from "./GiveworksForm.vue?vue&type=script&lang=js&"
import style0 from "./GiveworksForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports